import { atom as _atom } from '@exodus/jotai';
import { exodusAtom, selectorsAtomsAtoms } from './atoms.js';
export function atom(read, write) {
    const getter = (get, opts) => {
        const exodus = get(exodusAtom);
        const selectors = get(selectorsAtomsAtoms);
        const signal = opts.signal;
        return read(get, { signal, exodus, selectors });
    };
    const setter = (get, set, value) => {
        const exodus = get(exodusAtom);
        const selectors = get(selectorsAtomsAtoms);
        return write(get, set, value, { exodus, selectors });
    };
    const _read = typeof read === 'function' ? getter : read;
    const _write = typeof write === 'function' ? setter : write;
    return _write ? _atom(_read, _write) : _atom(_read);
}
